import app from './app';
import user from './user';
import photos from './photos';
import moments from './moments';
import design from './design';
import books from './books';
import orders from './orders';
import stats from './stats';
import analytics from './analytics';
import giftcards from './giftcards';

export default [app, user, photos, moments, design, books, orders, stats, analytics, giftcards];



// WEBPACK FOOTER //
// ./app/redux/sagas/index.js